import React from "react";
import {
    Col,
    Divider,
    Drawer,
    Form,
    Input,
    Row,
} from "antd";
import { Button } from "src/components/actions/button";
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg";
import { useAppData } from "src/store/app-data";
import {
    whiteSpaceValidation
} from "src/utils/helpers";
import styled from "styled-components";
import { PlusOutlined} from "@ant-design/icons";

export function SendPromoCodeDrawer({
   title,
   onClose,
   onSave,
   idUser
}) {

    const layoutConfig = useAppData((state) => state.layoutConfig);
    const [ isLoading, setIsLoading] = React.useState(false)

    const [form] = Form.useForm();

    function prepareData(values) {
        return {
            _method: "PUT",
            code: values.code,
            userIds: [idUser]
        };
    }


    async function onSubmit(values) {
        setIsLoading(true);
        const baseData = prepareData(values)

        try {
            await onSave(baseData);
            onClose();
            form.resetFields();
        } finally {
            setIsLoading(false);
        }
    }

    const id = idUser;
    function handleClose() {
        onClose();
        form.resetFields();
    }

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "80%"}
            title={title}
            onClose={handleClose}
            open
        >
            <FormEdit form={form} layout={"vertical"} onFinish={(values) => onSubmit(values)}>

                <StyledFormItem
                    label={"Код промокода"}
                    key={id + "_code"}
                    name={"code"}
                    rules={[
                        {
                            required: true,
                            message: "Введите код",
                        },
                        {
                            validator: whiteSpaceValidation
                        }
                    ]}
                >
                    <Input maxLength={255}/>
                </StyledFormItem>
                <ButtonRow>
                    <ButtonCol>
                        <Button
                            danger
                            onClick={() => {
                                form.resetFields();
                            }}
                            icon={<RotateClockwiseSvg />}
                        >
                            Вернуть
                        </Button>
                    </ButtonCol>
                    <ButtonCol>
                        <Button onClick={handleClose} icon={<CloseSvg />}>
                            Закрыть
                        </Button>
                    </ButtonCol>
                    <ButtonCol>
                        <Button
                            icon={<SaveSvg />}
                            type="primary"
                            htmlType="submit"
                            disabled={isLoading}
                        >
                            Отправить
                        </Button>
                    </ButtonCol>
                </ButtonRow>
            </FormEdit>
        </DrawerEdit>
    );
}

const DrawerEdit = styled(Drawer)``;

const FormEdit = styled(Form)``;

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`;

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`;

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`;

const RowFlex = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`

